import { NameOfChildRoutes, NamesOfParentRoutes, PERMISSION, ROLES } from "@shared/constants";

import { User } from "../models";
import { tokenHandler } from "../utils";

export const getUserPermissions = (userParam?: User, hospitalId?: number): string[] => {
  const user: User = userParam || tokenHandler.getUser();

  if (!user || !user.user_roles) {
    return [];
  }

  const permissions: string[] = [];
  const userRoles = hospitalId ? user.user_roles.filter((ur) => ur.hospital_id === hospitalId) : user.user_roles;
  userRoles.forEach((ur) => {
    permissions.push(...(ur.role.permissions ? ur.role.permissions.map((p) => p.name) : []));
  });

  return permissions;
};

export const checkPermission = (permission: string, user?: User, hospitalId?: number): boolean => {
  const userPermissions = getUserPermissions(user, hospitalId);

  return !!userPermissions.find((up) => up === permission);
};

export const checkAuthUserPermission = (permission: string, hospitalId?: number): boolean => {
  const user: User = tokenHandler.getUser();
  let userPermissions = getUserPermissions(user, hospitalId);

  if (!userPermissions.length && isAppAdmin(user)) {
    userPermissions = getUserPermissions(user);
  }

  return !!userPermissions.find((up) => up === permission);
};

export const checkPermissions = (permissions: string[], user?: User): boolean => {
  const userPermissions = getUserPermissions(user);
  return permissions.some((p) => userPermissions.find((up) => up === p));
};

export const getDefaultUrl = (user: User) => {
  if (checkPermission(PERMISSION.VIEW_HOSPITAL_DASHBOARD, user)) {
    return `${NamesOfParentRoutes.MANAGEMENT}${NameOfChildRoutes.MANAGEMENT.DASHBOARD.ROOT}${NameOfChildRoutes.DASHBOARD.HOSPITAL}`;
  }

  if (checkPermission(PERMISSION.VIEW_USERS, user)) {
    return `${NamesOfParentRoutes.MANAGEMENT}${NameOfChildRoutes.MANAGEMENT.USERS.ROOT}`;
  }

  if (checkPermission(PERMISSION.VIEW_STATIONS, user)) {
    return `${NamesOfParentRoutes.MANAGEMENT}${NameOfChildRoutes.MANAGEMENT.STATIONS.ROOT}`;
  }

  if (checkPermission(PERMISSION.VIEW_PATIENTS, user)) {
    return `${NamesOfParentRoutes.MANAGEMENT}${NameOfChildRoutes.MANAGEMENT.PATIENTS.ROOT}`;
  }

  if (checkPermission(PERMISSION.PATIENT_DASHBOARD, user)) {
    return `${NamesOfParentRoutes.PATIENT}${NameOfChildRoutes.PATIENT.FORMS.ROOT}`;
  }

  return `${NamesOfParentRoutes.AUTH}`;
};

export const handleUnauthorizedError = (requestUrl?: string) => {
  if (!requestUrl || !requestUrl.includes(NamesOfParentRoutes.AUTH)) {
    window.location.href = `${NamesOfParentRoutes.AUTH}${NameOfChildRoutes.AUTH.LOGIN}`;
    tokenHandler.removeAll();
  }
};

export const isAppAdmin = (user: User) => {
  return Boolean(
    user.user_roles?.find(
      (ur) => ur.hospital === null && (ur.role.name === ROLES.SUPER_ADMIN || ur.role.name === ROLES.ADMIN),
    ),
  );
};

export const getAllowedHospitalIds = (user: User | null) => {
  const result = new Set<number | null>();
  user && user.user_roles && user.user_roles.map((ur) => result.add(ur.hospital?.id || null));
  return Array.from(result);
};
